export default __webpack_public_path__ + "static/media/JointerImg.ce4b685a.png";